import { Container, Heading } from '@ingeniorforeningen/figurine-core';
import { SeverityLevel } from '@microsoft/applicationinsights-web';
import { useRouter } from 'next/router';
import { useEffect } from 'react';
import appInsights from '../appInsights';
import Tracker from '../tracker';
import Layout from '@/layouts/layout';

const Custom404 = () => {
    const { asPath, isPreview, locale } = useRouter();

    useEffect(() => {
        Tracker.trackError(404);
        appInsights.trackTrace({
            message: `Page Not Found (404)`,
            properties: {
                url: asPath,
                isPreview,
            },
            severityLevel: SeverityLevel.Error,
        });
    }, [asPath, isPreview]);

    return (
        <Layout>
            <title>{locale === 'da' ? 'Siden kunne ikke findes' : 'Page not found'}</title>
            <Container style={{ paddingTop: '7em' }}>
                <Heading
                    align="center"
                    type="h1"
                    text={locale === 'da' ? 'Vi kan ikke finde siden' : 'This page does not exist'}
                />
                <Heading
                    align="center"
                    type="h2"
                    text={
                        locale === 'da' ? 'Vi beklager ' : 'We are sorry '
                    }
                />
            </Container>
        </Layout >
    );
};
export default Custom404;
